export const ZIP_CODE_REGEX = /^([a-za-z0-9]{5,15})*$/
